import { render, staticRenderFns } from "./IconOrderHome.vue?vue&type=template&id=ce5d6338&scoped=true"
import script from "./IconOrderHome.vue?vue&type=script&setup=true&lang=js"
export * from "./IconOrderHome.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce5d6338",
  null
  
)

export default component.exports